module.exports = __webpack_public_path__ + "static/media/image4.bb340e59.jpeg";